import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Kanban, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  kanban: Kanban;
  retrieveKanban(project: Boundaries["retrieveKanban"]["request"]): void;
}

function useRetrieveKanban(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    kanban: useSelector(() => selector.getKanban(project)),
    isRequestPending: useSelector(() =>
      selector.isRetrieveKanbanRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveKanbanRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveKanbanRequestFailure(project),
    ),
    retrieveKanban: core.retrieveKanban,
  };
}

export { useRetrieveKanban };
